import React from 'react'

const NoResultContent = (props) => {
    const { message } = props;
    const isDisplay = props.isDisplay === false ? false : true;
    const alertType = props.type === 'danger' ? 'danger' : 'info';
    return (
        <>
            {message !== null && message !== undefined &&
                <div className={`alert alert-${alertType}`} role="alert">
                    <span className='w-100 bs5 d-block'><div className='text-center' dangerouslySetInnerHTML={{ __html: message }} /></span>
                    {isDisplay &&
                        < button type="button" className="close" data-dismiss="alert" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    }
                </div>
            }
        </>
    )
}

export default NoResultContent
